import { Component, inject, ViewChild } from '@angular/core';
import { PageComponent, FormComponent, FormInput, FormHandlingComponent } from '@tytapp/common';
import { CommunicationPrefsApi, ApiCommunicationPref, ApiUser } from '@tytapp/api';
import { UserService } from '@tytapp/user';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isOffline } from '@tytapp/environment-utils';

@Component({
    selector: 'app-communication-preference',
    templateUrl: './communication-preference.component.html',
    styleUrls: ['./communication-preference.component.scss']
})
export class CommunicationPreferenceComponent extends PageComponent implements FormHandlingComponent {
    private userService = inject(UserService);
    private communicationPrefsApi = inject(CommunicationPrefsApi);
    private matSnackBar = inject(MatSnackBar);

    state = 'loading';
    user: ApiUser;

    @FormInput()
    newsletter: boolean = false;

    @FormInput()
    newsletter_weekly: boolean = false;

    @FormInput()
    army: boolean = false;

    @FormInput()
    shop: boolean = false;

    submitSuccess = false;

    communicationPref: ApiCommunicationPref[];

    async init() {
        this.subscribe(this.userService.userChanged, async user => {
            this.user = user;
            if (!this.user) {
                this.redirection.go('/', true);
                return;
            }

            if (isOffline()) {
                this.state = 'offline';
                return;
            }
            this.communicationPref = await this.communicationPrefsApi.getCommunicationPrefs().toPromise()
                .then(prefs => prefs.filter(pref => pref.category === 'newsletter'));
            this.state = 'ready';
        });
    }

    get emailPrefs(): ApiCommunicationPref[] {
        if (!this.communicationPref)
            return [];

        let entitled = this.user?.entitled ?? false;
        return this.communicationPref.filter(x => x.provider === 'email' && (!x.premium || entitled));
    }

    submitting = false;

    @ViewChild('form')
    form: FormComponent;

    async submit() {
        let prefs: ApiCommunicationPref[] = this.emailPrefs.map(x => ({
            provider: x.provider,
            provider_id: x.provider_id,
            allowed: x.allowed
        }));

        let param = {
            communication_prefs: prefs
        };
        try {
            this.submitting = true;
            await this.communicationPrefsApi.patchCommunicationPrefs(param as any).toPromise();
            this.submitting = false;
            this.notify(`Your newsletter preferences have been saved`);
        } catch (e) {
            this.submitting = false;
            if (e.json)
                e = e.json();

            this.logger.error('Error while updating communication prefs: ');
            this.logger.error(e.message || e.error);
            this.logger.inspect(e);

            this.form.showError(e.message || e.error || 'Uh oh, an error occurred while updating your preferences. Please try again- if the issue persists please contact support.');
        }
    }

    notify(message: string) {
        this.matSnackBar.open(message, undefined, { duration: 3000 });
    }

}
